import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import * as React from 'react';
import { RenameAction } from '../../actions/rename/RenameAction';
import CommandStrings from '../Commands.resx';
import { ShowOnlyWithSelection } from '../../selectionVisibility/SelectionVisibility';
import KeyboardMapStrings from '../../keyboard/KeyboardMap.resx';

export const renameCommand: ICommand = {
  key: new Facet('rename').id,
  automationId: 'renameCommand',
  name: CommandStrings.Rename,
  action: <ShowOnlyWithSelection><RenameAction /></ShowOnlyWithSelection>,
  iconProps: {
    iconName: 'rename'
  },
  keytipProps: {
    content: KeyboardMapStrings.renameDesc,
    keySequences: ['F2']
  }
};
